import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {HeaderNotificationsService} from './header-notifications.service';
import {NotificationService} from '../../../API/notification.service';
import {filter} from 'rxjs/operators';
import {matchActionStatus} from '../../../../../projects/api/src/reactive-service.abstract';
import {Router} from '@angular/router';
import {EventLogApiService} from '../../../../../projects/api/src/event-log/event-log-api.service';
import {of} from 'rxjs/internal/observable/of';
import {InsparkMessageService} from '@inspark/inspark-components';
import {TranslateService} from '@ngx-translate/core';
import { SemRestRequestService } from '../../../../../projects/api/src/sem-rest-request/sem-rest-request.service';
import { ApiList } from '../../../API/api-list.enum';
import {environment} from '../../../../environments/environment';
import {LocalStorageService} from '../../../../../projects/api/src/locale-storage/locale-storage.service';

type BlockStates = 'none' | 'ask' | 'syn' | 'fin';
const UNBLOCKED = 'unblocked';
const BLOCKED = 'blocked';
const statesMap: { [key: string]: BlockStates } = {none : 'ask', ask : 'syn', syn : 'fin', fin : 'fin'};

const TIMEOUT = 30 * 1000;
const CHECK_SOUND_BLOCK_TIMEOUT = 15 * 1000;
const MAX_NOTIFY_ID = 1000;
const DELAY_STEP = 100;

const enum ClearMode {
  'strict',
  'any'
}

const eventLogUrl = environment.backEndUrlPrefix.substring(0,environment.backEndUrlPrefix.indexOf('sem-restservices')) + 'app/#!/main/eventslog/list';

@Component({
    selector: 'app-header-notifications',
    templateUrl: './header-notifications.component.html',
    styleUrls: ['./header-notifications.component.scss'],
    standalone: false
})
export class HeaderNotificationsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() acceptMessage?: any;
  @Output() notifyMessage? = new EventEmitter<any>();
  protected readonly eventLogUrl = eventLogUrl;
  public overlayIsOpen: boolean;
  public isSoundOn = true;
  public currentSoundEvent = null;
  private notifyId = null;
  private active = false;
  private autosyncTimer = null;
  private blockState: BlockStates = 'none';
  private lastMessage: any;

  private subscriptions = [];

  @HostListener('window:focus', ['$event'])
  onFocus(event?: any): void {
      this.active = true;
  }

  @HostListener('window:blur', ['$event'])
  onBlur(event?: any): void {
      this.active = false;
  }

  constructor(private headerNotificationService: HeaderNotificationsService,
              private localStorageApi: LocalStorageService,
              private element: ElementRef,
              private notifyService: NotificationService,
              private eventLogApiService: EventLogApiService,
              private request: SemRestRequestService,
              private router: Router,
              private messageService: InsparkMessageService,
              private translate: TranslateService) {
  }

  public clickedOutsideOverlay(event) {
    if (!this.element.nativeElement.contains(event.target)) {
      this.overlayIsOpen = false;
    }

  }


  public showMessageWindow(popup?: boolean) {
    const messages = popup ? this.getMessages().filter(msg => msg.popup === true) : this.getMessages();
    let critical = 0, error = 0, warning = 0, info = 0 , success = 0;
    let severity = null;
    for(let i = 0; i<messages.length; i++) {
      if (i === 0) {
        this.lastMessage = messages[i];
      }

      if (messages[i].status === 'critical'){
        critical++;
        severity = 'error';
      } else if (messages[i].status === 'error') {
        error++;
        severity = 'error';
      } else if (messages[i].status === 'warning' || messages[i].status === 'falsevalue') {
        warning++;
        if (severity !== 'error') {
          severity = 'warn';
        }
      } else if (messages[i].status === 'none') {
        info++;
        if (!['error', 'warn'].includes(severity)) {
          severity = 'info';
        }

      } else if (messages[i].status === 'success') {
        if(!['error', 'warn', 'info'].includes(severity)){
          severity = 'success';
        }
        success++;
      } else {
        info++;
        if (!['error', 'warn'].includes(severity)) {
          severity = 'info';
        }
      }
    }

    if (severity) {
      const elements = document.getElementById('app_header_component_ustas');
      const classList = elements.classList;
      const classArray = Array.from(elements.classList);
      document.getElementById('app_header_component_ustas').classList.add('is-header-notification_active');
      document.getElementById('app_menu_ustas').classList.add('c-sidebar-ustas');
      document.getElementById('app_main_content_ustas').classList.add('c-main-content-ustas');
      this.notifyMessage.emit(this.lastMessage);
    } else {
      this.onReject();
    }

  }

  onReject() {
    document.getElementById('app_header_component_ustas').classList.remove('is-header-notification_active');
    document.getElementById('app_menu_ustas').classList.remove('c-sidebar-ustas');
    document.getElementById('app_main_content_ustas').classList.remove('c-main-content-ustas');
    this.notifyMessage.emit(undefined);
  }

  switchSoundCommand() {
    this.request
    .baseUrlAppend(ApiList.Db, ApiList.User, ApiList.Profile, 'soundon')
    .baseUrlAppendByStrParam(`?soundon=${!this.isSoundOn}`)
    .update({}).subscribe(() => console.log(''));
    this.switchSound(true);
  }
  switchSound(local=false) {
    this.currentSoundEvent = null;
    this.notifyService.removeAudio();
    this.isSoundOn = !this.isSoundOn;
    if (local) {
      this.localStorageApi.save(true, 'notifyIsSoundOn', (this.isSoundOn + '').toLowerCase());
    }
    this.checkSoundStream();
  }

  public getMessages() {
    return this.headerNotificationService.messages;
  }

  public deleteMessageById(id): void {
    this.headerNotificationService.deleteMessageById(id);
  }

  public sendClearCommand() {
    if (confirm(this.translate.instant('Do you want accept all events?'))) {
      this.clear(true);
      this.request
      .baseUrlAppend(ApiList.Db, ApiList.User, ApiList.Profile, 'event_read')
      .postFormData({}).subscribe((result) => {
          this.showMessageWindow(true);
        }
      );
    }
  }
  public clear(local = false): void {

    if (local) {
      const ids = [...this.headerNotificationService.messages].filter(m => !!m.eid).map(m => m.eid + '');
      this.eventLogApiService.addMessages(ids, 'Событие обработано').subscribe(activity => {
        this.messageService.success('Events successfully accepted');
        this.notifyService.sendEvent({name: 'reload', params: {mode: 'weak'}}, of({}));
      });
    }

    [...this.headerNotificationService.messages].forEach(item => {
      if (this.currentSoundEvent && this.currentSoundEvent.id === item.id) {
        this.currentSoundEvent = null;
        this.notifyService.removeAudio();
      }
      this.headerNotificationService.deleteMessageById(item.id);
    });

    this.checkSoundStream();
  }

  ngOnInit() {
    this.isSoundOn = this.localStorageApi.load(true, 'notifyIsSoundOn') !== 'false';
    this.registerNotify();
    this.clearPlaySoundByTimeout();
    let ctrl = this;
    setTimeout(function() { ctrl.showMessageWindow(); }, 2000);
    this.notifyService.webSocket();
    this.subscriptions = [
      this.notifyService.event$.subscribe(this.askPlaySoundBlock.bind(this)),
      this.notifyService.events.pipe(filter(matchActionStatus('done', ['custom']))).subscribe((event) => {
          if (!event.action.params) { return;}

          switch(event.action.params.type) {
            case 'read_all_event':
              this.clear();
              break;
            case 'read_event':
               this.removeSound({eid: event.result.eid});
               this.checkSoundStream();
              break;
          case 'sound_on':
              if (!this.isSoundOn) {
                this.switchSound();
              }
              break;
          case 'sound_off':
                if (this.isSoundOn) {
                  this.switchSound();
                }
                break;


            case 'sound':
              this.parseSound(event);
              break;
          }

      })
    ];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.acceptMessage?.currentValue) {
      const item = changes.acceptMessage.currentValue;
      this.removeSound(item, true);
      this.request
        .baseUrlAppend(ApiList.Db, ApiList.User, ApiList.Profile, 'event_read')
        .baseUrlAppendByStrParam(`?id=${item.eid}`)
        .postFormData({}).subscribe((result) => {
          this.headerNotificationService.deleteMessageById(item.id);
          this.showMessageWindow(true);
        }
      );
    }
  }

  parseSound(event): void {
    const data = event.result.data;
    if (data.closed === true || data.processed === true) {
      return;
    }
    const sound =  (data.media || []).filter( media => media.type === 'SOUND');
    const snd = sound.length > 0 ? sound.pop() : {url: '', popup: false};
    this.headerNotificationService.addMessage({
      header: data.name,
      details: data.msg,
      timestamp: data.timestmp,
      status: data.criticalName,
      shortname: data.shortname,
      serialnumber: data.serialnumber,
      eid: data.id,
      sound: snd.url,
      popup: snd.popup,
    });
    this.showMessageWindow(true);
    this.checkSoundStream();
    this.checkIsSoundBlockedTimer();
  }

  checkIsSoundBlockedTimer() {
    console.log('Check block ==>', this.autosyncTimer ? 'already set' : 'should be set');

    if (this.autosyncTimer == null) {
        this.autosyncTimer = setInterval(
                () => {
                    if (this.getMessages().length > 0 && !this.isOwnBlock()) {
                      console.log('Stream not empty ==> check sound | block is ', this.blockState);
                      this.checkSoundStream();
                    } else {
                      console.log('Stream is empty or blocked by current window ==> clear timer | block is ', this.blockState);
                      clearTimeout(this.autosyncTimer);
                      this.autosyncTimer = null;
                    }
                },
                CHECK_SOUND_BLOCK_TIMEOUT
        );
    }
  }
  /**
   *  Для локировки запуска звука в нескольких вкладках релизуется следующий алгоритм:
   * 1) Проверям по событий focus активную вкладку, если есть то пишем в localstorage блокировку
   * 2) ждем 50 мс если проверяем есть ли блокировка в localstorgage, если есть,
   *    то ничего не делаем, если нет, то все вкладки пытаются записть свою блокировку
   * 3) ждем еще 50 мс, проверям чья блокировка в localstorage, та чья блокировка
   *    стоит на той вкладке звук и запускаем
   */
  checkSoundStream() {
    this.clearPlaySoundByTimeout();
    let delayBlock = Math.floor((Math.random() * 10) + 1) * DELAY_STEP;
    if (this.active) {
      this.askPlaySoundBlock();
      delayBlock = 10;
    }

    setTimeout(() => {
      if (this.isSoundOn && !this.currentSoundEvent) {
        // Необходимо подождать пока обновится статус хранилища, чтобы быть увереным,
        // что один и тот же статус не читается дважды
        this.askPlaySoundBlock(); // ack
        setTimeout( () => {
            if (!this.askPlaySoundBlock()) { return; } // syn

            this.currentSoundEvent = (this.getMessages() || []).find(m => !!m.eid && !!m.sound);
            if (this.currentSoundEvent && this.currentSoundEvent.sound) {
                this.notifyService
                  .playSound(this.currentSoundEvent.sound)
                  .catch( e =>{
                      console.error('Error when tring play sound.', e);
                      console.log('Clear block in local storage.');
                      this.clearPlaySoundBlock();
                      this.clearSoundFlags();
                  });
            } else {
              this.clearPlaySoundBlock(); // fin
            }
        }, delayBlock);
      }
  }, delayBlock);
  }

  clearSoundFlags() {
    this.currentSoundEvent = null;
    this.notifyService.removeAudio();
  }

  removeSoundCommand(item, event) {
    this.removeSound(item, true);
    this.request
    .baseUrlAppend(ApiList.Db, ApiList.User, ApiList.Profile, 'event_read')
    .baseUrlAppendByStrParam(`?id=${item.eid}`)
    .postFormData({}).subscribe((result) => {
       this.headerNotificationService.deleteMessageById(item.eid);
       const list = this.headerNotificationService.messages;
        if (list && list.length > 0) {
          this.notifyMessage.emit(this.headerNotificationService.messages[0]);
        } else {
          this.notifyMessage.emit(undefined);
        }
      }
    );
    event.stopPropagation();
  }

  removeSound(item, local = false) {
    if (item.eid) {
      if (this.currentSoundEvent && +this.currentSoundEvent.eid === +item.eid) {
        this.clearSoundFlags();
      }
      this.headerNotificationService.deleteMessageByEId(item.eid);

      // событие только если управляющая команда была запущена в текущей вкладке
      if (local) {
        this.eventLogApiService.addMessages([item.eid], 'Событие обработано').subscribe(activity => {
          this.messageService.success('Event successfully accepted');
          this.notifyService.sendEvent({name: 'reload'}, of({}));
        });
      }
    }

  }

  removeSoundHandler(item, event) {
    this.removeSound(item);
    this.checkSoundStream();
    event.stopPropagation();
  }

  redirectToEvents(id) {
    if (id != null) {
      this.overlayIsOpen = false;
      this.notifyService.sendEvent({name: 'reload', params: {mode: 'weak'}}, of({}));
      //this.router.navigate(['main', 'eventslog', 'list'], {queryParams: {id}});
      if ( this.router.url === '/main/eventslog/list' ) {
        window.open(`${this.eventLogUrl}?id=${id}`, '_self');
      } else {
        window.open(`${this.eventLogUrl}?id=${id}`, '_blank');
      }
    }
  }

  ngOnDestroy() {
    this.clearPlaySoundBlock();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private registerNotify(): void {
    if (this.notifyId > 0) { return; }
      const nid = parseInt(this.localStorageApi.load(true, 'notifyIdCounter'));
      if (nid > 0 && nid < MAX_NOTIFY_ID) {
        this.notifyId = nid + 1;

      } else {
        this.notifyId = 1;
      }
      this.localStorageApi.save(true, 'notifyIdCounter', this.notifyId);
  }

  private getSoundPlaingInfo(): {action: string; id: number; time: number}  {
    const json = this.localStorageApi.load(true, 'playNotifyStatus');
    if (!json) {
      return {action: UNBLOCKED, id: 0, time: 0};
    }
    return json;
  }

  private getSoundPlaingTimeout(): number {
    const json = this.getSoundPlaingInfo();
    return json.time === 0 ? 0 : (new Date().getTime()) - json.time;
  }

  clearPlaySoundByTimeout() {
    if (this.getSoundPlaingTimeout() > TIMEOUT) {
      this.clearPlaySoundBlock(ClearMode.any);
    }
  }

  clearPlaySoundBlock(mode: ClearMode = ClearMode.strict) {
    if (mode === ClearMode.strict) {
        const json = this.getSoundPlaingInfo();
        if (json.id !== this.notifyId) { return; }
    }
    this.localStorageApi.save(true, 'playNotifyStatus', null);
    this.blockState = 'none';
  }

  isOwnBlock() {
      const json = this.getSoundPlaingInfo();
      return json.action === BLOCKED && json.id === this.notifyId;
  }

  askPlaySoundBlock(): boolean {
    const json = this.getSoundPlaingInfo();
    const notBlocked = json.action === UNBLOCKED;
    const ownBlock = json.action === BLOCKED && json.id === this.notifyId;

    if (notBlocked || ownBlock) {
        this.localStorageApi.save(true, 'playNotifyStatus', JSON.stringify({action: BLOCKED, id: this.notifyId, time: new Date().getTime()}));
        this.blockState = statesMap[this.blockState];
        return true;
    }
    this.blockState = 'none';
    return false;
  }
}
